class ServiceListController {
  /**
   * Services Controller
   * @memberof pims
   * @ngdoc controller
   * @param {service} Services - Service Interface
   */
  constructor(Services) {
    'ngInject';

    Object.assign(this, {
      Services
    });
    this.init();
  }
  /**
   * Load all services and assign to view
   */


  init() {
    this.Services.list().then(({
      data
    }) => {
      const {
        data: services,
        pagination
      } = data;
      this.services = services;
      this.pagination = pagination;
    });
  }

}

ServiceListController.$inject = ["Services"];
angular.module('pims').controller('ServiceListController', ServiceListController);
